import { Button, FormControl, Grid } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import GKModal from "components/GKModal";
import GKTextField from "components/GKTextField";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";

const HistoricalModal = ({ open, setOpen, type, refetch }) => {
  const query = useQueryClient();
  const { id } = useParams();

  const { mutate: handleAddHMP } = useMutation({
    mutationKey: ["ADD_HMP"],
    mutationFn: (data) =>
      axiosInstance.post(`/admin-instrument-hmp/${id}/create/`, data),
    onSuccess: () => {
      refetch();
      setOpen(false);
    },
    onError: () => {},
  });

  const { mutate: handleUpdateCMP } = useMutation({
    mutationKey: ["UPDATE_CMP"],
    mutationFn: (data) =>
      axiosInstance.post(`/admin-instrument-cmp/${id}/update/`, data),
    onSuccess: () => {
      refetch();
      query.refetchQueries([QueryKeys.COMPANY_LIST]);
      setOpen(false);
    },
    onError: () => {},
  });

  const { control, handleSubmit } = useForm({
    defaultValues: {
      date: "",
      price: "",
    },
  });

  const onSubmit = (values) => {
    if (type === "HMP") {
      handleAddHMP(values);
    } else {
      handleUpdateCMP(values);
    }
  };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={type === "HMP" ? "Add HMP" : "Update CMP"}
      footer={
        <Grid container justifyContent={"flex-end"} gap={1}>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            type="submit"
            form="create-historical-modal-form"
            variant="outlined"
          >
            {type === "HMP" ? "Save" : "Update"}
          </Button>
        </Grid>
      }
    >
      <form id="create-historical-modal-form" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <Controller
                name="date"
                control={control}
                render={({ field }) => (
                  <GKTextField
                    inputLabel="Date"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...field}
                  />
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <Controller
                name="price"
                control={control}
                render={({ field }) => (
                  <GKTextField inputLabel="Price" {...field} type="number" />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </GKModal>
  );
};

export default HistoricalModal;
